<template>
    <ul class="Tabs nav nav-tabs" role="tablist">
        <slot></slot>
    </ul>
</template>

<script type="text/babel">
import NavigationProvider from 'dashboard-js/providers/NavigationProvider'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [RestoreOnPageBack],

    props: ['name', 'activeTab'],

    data() {
        return {
            currentTab: this.activeTab,
        }
    },

    watch: {
        currentTab(newTab) {            
            this.activateTabForHash(newTab);
        }
    },


    mounted() {
        this.registerTabClickHandler()

        this.onPageRestore(() => this.activateTabForHash(this.currentTab))
        this.onPageVisit(() => {
            const hash = window.location.hash ? window.location.hash.substring(1) : null;

            if (hash) {
                return this.activateTabForHash(hash);
            }
            if (window.Spark.tab) {
                return this.activateTabForHash(window.Spark.tab)
            }

            if (NavigationProvider.requestedTab()) {
                return this.activateTabForHash(NavigationProvider.requestedTab())
            }

            if (window.location.hash) {
                return this.activateTabForWindowHash()
            }

            if (window.location.search.substring(0, 5) === '?tab=') {
                return this.activateTabForHash(window.location.search.substring(5));
            }

            this.activateFirstTab()
        })
    },

    methods: {
        activateFirstTab() {
            const tab = $(this.$el)
                .find('a[data-toggle="tab"]')
                .first()

            tab.tab('show')

            this.registerTabChange(tab.attr('href').substring(1))
        },

        activateTabForWindowHash() {
            this.activateTabForHash(window.location.hash.substring(2))
        },

        activateTabForHash(hash) {
            this.removeActiveClassFromTabs()

            const tab = $(this.$el).find(`a[href="#${hash}"][data-toggle="tab"]`)

            if (tab.length > 0) {
                tab.tab('show')

                this.registerTabChange(hash)
            } else {
                this.activateFirstTab()
            }
        },

        registerTabChange(name) {
            this.currentTab = name
            this.saveState()

            NavigationProvider.registerTab(name)

            if (Spark.client === 'app') {
                window.scrollTo(0, 0)
            }

            Bus.$emit('tabChanged', { name })
        },

        registerTabClickHandler() {
            const self = this

            $(this.$el)
                .find('a[data-toggle="tab"]')
                .on('click', function() {
                    self.removeActiveClassFromTabs()
                    self.registerTabChange(
                        $(this)
                            .attr('href')
                            .substring(1)
                    )
                })
        },

        removeActiveClassFromTabs() {
            $(this.$el)
                .find('li')
                .removeClass('active')
        },

        getCacheKey() {
            return this.$options._componentTag + '.' + this.name
        },
    },
}
</script>
